import React from 'react'
import Pacote from './Pacote'
import { adicionarDenuncia, adicionarComplemento } from '../../services/DenunciaServico'
import { obterPorData } from '../../util/Data'

export default function BotaoEnviar(props) {
    if (!props.linhaDoTempo) {
        return null;
    }
    if (props.linhaDoTempo.emPauta !== "submit") {
        return null;
    }

    const abreFormularioEnviarArquivos = () => {
        props.atuLinhaDoTempo('enviarArquivos')
    }

    const enviar = () => {
        props.setMensagem({ tipo:'LIMPAR', texto:'' })
        props.setShowSpinner(true)
        Pacote.obter(props)
        .then( pacote => {
            let protocolo = props.complementacao
            if (props.complementacao === "") {
                protocolo = obterPorData(new Date()).protocolo;
            }

            let api = null
            if (props.formularioEmPauta === "Denuncia") {
                api = adicionarDenuncia
            } else if (props.formularioEmPauta === "Protocolo" || props.formularioEmPauta === "Narrativa") {
                api = adicionarComplemento
                pacote.denuncia.status = "COMPLEMENTO"
            }

            pacote.denuncia = { ...pacote.denuncia, protocolo }
            api(pacote.denuncia,pacote.fotocopias)
            .then( respEnvia => {
                props.setConteudo(respEnvia)
                props.setCorrespondenciaEntregue({ protocolo, show:true })
                props.showFormulario("CorrespondenciaEntregue")
                props.setShowSpinner(false)
            })
            .catch( msgErroEnvia => {
                props.setMensagem(msgErroEnvia)
                props.setShowSpinner(false)
            })
        })
    }

    return(
        <div className="mt-4">
            <div className="d-flex justify-content-between">
                <button 
                    type="button" 
                    className="btn btn-outline-primary" 
                    onClick={ abreFormularioEnviarArquivos }
                >
                    Anterior
                </button>
                <button 
                    type="button" 
                    className="btn btn-success " 
                    onClick={ enviar }
                >
                    Enviar dados
                </button>
            </div>
        </div>
    )
}